// extracted by mini-css-extract-plugin
module.exports = {"TileGroups__group":"styles_TileGroups__group__wOORd","TileGroups__card":"styles_TileGroups__card__ycDGQ"};